import React from 'react';
import Aux from '../../hoc/Aux';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const textTermsOfUse = (props) => {

  const ht = useCustomHtmlTranslation();

  return (
    <Aux>
      <h1><center>{ ht('content.terms_of_use.headline') }</center></h1><br />
      { ht('content.terms_of_use') }
    </Aux>
  )
};

export default textTermsOfUse;



// WEBPACK FOOTER //
// ./src/components/Shared/TextTermsOfUse.js